module.exports = __webpack_public_path__ + "static/media/recently-approved-empty-state.8fde22d3.svg";